import { Injectable, signal } from '@angular/core';

export type LayoutWidth = 'standard' | 'large';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private _maxWidth = signal<LayoutWidth>('large');

  maxWidth = this._maxWidth.asReadonly();

  setMaxWidth(width: LayoutWidth) {
    this._maxWidth.set(width);
  }

  resetWidth() {
    this._maxWidth.set('large');
  }
}
